module.exports = __webpack_public_path__ + "2d471a399b1b90cf7428850970616b90.pdf";